export default __webpack_public_path__ + "static/media/NotoSansKR-Thin.cc4e8944.woff";